export const inNextTick = (fun: () => void) =>
  setTimeout(() => {
    fun();
  }, 0);
